(function () {
  class CollectionTitleSearch extends HTMLElement {
    static cache = new Map();

    constructor() {
      super();
      this.input = this.querySelector('input');
      this.results = this.querySelector('[role="listbox"]');
      this.status = this.querySelector('.omg-collection-search__status');
      this.moreButton = this.querySelector('.omg-collection-search__more');
      this.retryButton = this.querySelector('.omg-collection-search__retry');
      this.visibleResults = 8;
      this.timer = null;
    }

    connectedCallback() {
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));
      this.moreButton.addEventListener('click', () => {
        this.visibleResults += 8;
        this.render(this.matches || []);
      });
      this.retryButton.addEventListener('click', () => this.search());
    }

    onInput() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.search(), 250);
    }

    async search() {
      const query = this.input.value.trim();
      this.visibleResults = 8;
      this.clear();
      if (query.length < 2) return;
      if (this.dataset.mode === 'catalog') {
        this.catalogSearch(query);
        return;
      }
      try {
        const products = await this.loadProducts();
        const normalizedQuery = query.toLowerCase();
        this.matches = products.filter((product) => product.normalizedTitle.includes(normalizedQuery));
        this.render(this.matches);
      } catch (error) {
        this.status.textContent = this.dataset.errorText;
        this.retryButton.hidden = false;
      }
    }

    async loadProducts() {
      const key = this.dataset.collectionUrl;
      if (CollectionTitleSearch.cache.has(key)) return CollectionTitleSearch.cache.get(key);
      const promise = (async () => {
        const products = [];
        let page = 1;
        while (true) {
          const response = await fetch(`${key}/products.json?limit=250&page=${page}`, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Collection products unavailable');
          const data = await response.json();
          const fetched = data.products || [];
          products.push(...fetched.map((product) => ({
            title: product.title,
            normalizedTitle: product.title.toLowerCase(),
            handle: product.handle,
            image: product.images && product.images[0] ? product.images[0].src : '',
            price: product.variants && product.variants[0] ? product.variants[0].price : ''
          })));
          if (fetched.length < 250) break;
          page += 1;
        }
        return products;
      })();
      CollectionTitleSearch.cache.set(key, promise);
      return promise;
    }

    catalogSearch(query) {
      const terms = query.split(/\s+/).filter(Boolean).map((term) => `title:${term}`).join(' ');
      const url = new URL(this.dataset.searchUrl, window.location.origin);
      url.searchParams.set('q', terms);
      url.searchParams.set('type', 'product');
      url.searchParams.set('filter.v.availability', '1');
      window.location.assign(url.toString());
    }

    render(matches) {
      this.clear();
      if (!matches.length) {
        this.status.textContent = this.dataset.emptyText;
        return;
      }
      matches.slice(0, this.visibleResults).forEach((product) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `/products/${encodeURIComponent(product.handle)}`;
        link.setAttribute('role', 'option');
        link.textContent = product.title;
        item.appendChild(link);
        this.results.appendChild(item);
      });
      this.moreButton.hidden = matches.length <= this.visibleResults;
      this.input.setAttribute('aria-expanded', 'true');
    }

    clear() {
      this.results.replaceChildren();
      this.status.textContent = '';
      this.moreButton.hidden = true;
      this.retryButton.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }

    onKeydown(event) {
      const links = Array.from(this.results.querySelectorAll('a'));
      if (event.key === 'Escape') {
        this.clear();
        this.input.focus();
      } else if (event.key === 'ArrowDown' && links.length) {
        event.preventDefault();
        links[0].focus();
      }
    }
  }

  if (!customElements.get('collection-title-search')) {
    customElements.define('collection-title-search', CollectionTitleSearch);
  }

  function applyDefaultAvailability() {
    var params = new URLSearchParams(window.location.search);
    var isCollection = document.body.classList.contains('template-collection');
    var isCatalogSearch =
      document.body.classList.contains('template-search') &&
      params.get('q') === '*' &&
      params.get('type') === 'product';
    var availabilityFilter = document.querySelector('input[name="filter.v.availability"][value="1"]');

    if ((!isCollection && !isCatalogSearch) || !availabilityFilter || params.has('filter.v.availability')) return;

    params.set('filter.v.availability', '1');
    params.delete('page');
    location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDefaultAvailability, { once: true });
  } else {
    applyDefaultAvailability();
  }
})();
